import { createStore } from 'vuex';

const TOKEN_KEY = 'fytlix_member_token';
const CLIENT_KEY = 'fytlix_member_client';
const LANG_KEY = 'fytlix_member_lang';

function storedClientId() {
    const value = localStorage.getItem(CLIENT_KEY);
    return value ? parseInt(value, 10) : null;
}

export default createStore({
    state() {
        return {
            token: localStorage.getItem(TOKEN_KEY) || null,
            email: null,
            clients: [],
            selectedClientId: storedClientId(),
            person: null,
            loadingCount: 0,
            toast: null,
            // 'hr' or 'en'. Device default from localStorage; the logged-in member's saved choice overrides it.
            language: localStorage.getItem(LANG_KEY) || 'hr'
        };
    },
    getters: {
        isAuthenticated: (state) => !!state.token,
        selectedClient: (state) => state.clients.find((c) => c.client_id === state.selectedClientId) || null,
        loading: (state) => state.loadingCount > 0
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            if (token) localStorage.setItem(TOKEN_KEY, token);
            else localStorage.removeItem(TOKEN_KEY);
        },
        setEmail(state, email) {
            state.email = email;
        },
        setClients(state, clients) {
            state.clients = clients;
        },
        setSelectedClient(state, clientId) {
            state.selectedClientId = clientId;
            if (clientId) localStorage.setItem(CLIENT_KEY, clientId);
            else localStorage.removeItem(CLIENT_KEY);
        },
        setPerson(state, person) {
            state.person = person;
        },
        setLanguage(state, language) {
            state.language = language;
            localStorage.setItem(LANG_KEY, language);
        },
        incLoading(state) {
            state.loadingCount++;
        },
        decLoading(state) {
            state.loadingCount = Math.max(0, state.loadingCount - 1);
        },
        // A monotonically increasing id lets the Toast component re-trigger even for identical messages.
        showToast(state, { message, type = 'info' }) {
            state.toast = { message, type, id: Date.now() + Math.random() };
        },
        reset(state) {
            state.token = null;
            state.email = null;
            state.clients = [];
            state.selectedClientId = null;
            state.person = null;
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(CLIENT_KEY);
        }
    }
});
